import React, { createContext, useEffect, useState } from "react";

import { merge } from "lodash";

import { Settings, TextDirection } from "@ds-developer/models";
import { THEMES } from "@ds-developer/constants";
import { storeSettings } from "@ds-developer/frontend";

const defaultSettings = {
  direction: "ltr" as TextDirection,
  responsiveFontSizes: true,
  theme: THEMES.LIGHT,
};

const defaultValues = {
  settings: defaultSettings,
};

export const SettingsContext = createContext<{
  settings: Settings;
  saveSettings?: () => void;
}>(defaultValues);

export const SettingsProvider: React.FC<{
  settings: Settings;
  children: React.ReactNode;
}> = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(
    settings || defaultSettings,
  );

  const handleSaveSettings = (updatedSettings = {}) => {
    const mergedSettings = merge({}, currentSettings, updatedSettings);

    setCurrentSettings(mergedSettings);
    storeSettings(mergedSettings);
  };

  useEffect(() => {
    document.dir = currentSettings.direction;
  }, [currentSettings]);

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        saveSettings: handleSaveSettings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const SettingsConsumer = SettingsContext.Consumer;

export default SettingsContext;
